import {
  ClientVersionCheckResult,
  isClientVersionCheckResult,
} from "./types.generated";

export { ClientVersionCheckResult, isClientVersionCheckResult };
